import { isEmpty } from "oc-commons/Commons";

export function Image({
  width,
  height,
  url,
}: {
  width?: number | string;
  height?: number | string;
  url: string;
}) {
  if (isEmpty(url)) {
    return null;
  }
  return (
    <div
      className="image"
      role="img"
      aria-label={I18N("aria::Produktbild")}
      style={{
        backgroundImage: "url(" + url + ")",
        width: width,
        height: height,
      }}
    />
  );
}
